














































import { mapState } from 'vuex';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { RootState } from '@/types/state';
import { ProductInterface } from '@/types/product';

@Component({})
export default class HomeView extends Vue {
  protected featuredProducts: ProductInterface[] = [];

  @Getter('allProducts', { namespace: 'products' })
  protected products!: ProductInterface[];

  protected randomProduct(index: number) {
    if (!this.$store.state.products.isDataLoaded) {
      return false;
    }

    const unusedProducts = this.products.filter((product) => !this.featuredProducts.includes(product));

    if (unusedProducts.length < 1) {
      return false;
    }

    const randomIndex = Math.floor((Math.random() * (unusedProducts.length - 1)));
    this.featuredProducts[index] = unusedProducts[randomIndex];

    return true;
  }

}
